<script setup lang="ts">
import type { User, Uuid } from '~/composables/charon'

const { t } = useI18n()
const { charon } = useCharon()
const localePath = useLocalePath()

const props = defineProps<{
  userId: Uuid | null
}>()

const { data: user } = useAsyncData(
  `leaderboard-user-${props.userId}`,
  () => props.userId ? charon<User>(`/users/${props.userId}`) : Promise.resolve(null),
  {
    lazy: true,
    server: true,
    watch: [() => props.userId],
    transform: u => u ? ({ id: u.id, name: u.name }) : null,
  },
)
</script>

<template>
  <span
    v-if="!userId"
    class="flex flex-row gap-3 items-center text-slate-500 italic"
  >
    {{ t('jc.component.dungeonRunLeaderboard.unknownPlayer') }}
  </span>
  <NuxtLink
    v-else-if="user"
    class="hover:text-primary-highlighted active:text-primary-selected flex flex-row gap-3 items-center"
    :to="localePath({
      name: 'user-user',
      params: {
        user: user.name,
      },
    })"
  >
    <NuxtPicture
      :src="user.id"
      provider="xenos"
      :modifiers="{ scale: 10 }"
      sizes="400px tablet:512px laptop:384px desktop:444px"
      class="h-6 w-6 rounded-md overflow-hidden"
    />
    {{ user.name }}
  </NuxtLink>
</template>

<style scoped lang="postcss">

</style>
